import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface VentureContentResponse {
  status: number;
  content: string;
}

@Injectable({
  providedIn: 'root'
})
export class AIService {

  constructor(private _http: HttpClient) { }

  generateVentureContent(payload: any): Observable<VentureContentResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this._http.post<VentureContentResponse>(
      environment.apiUrl + 'api/aiventure/generate-venture-content',
      payload,
      httpOptions
    );
  }
}
